function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M0 55.546h82.839V0H0z"
}));

var _ref2 = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M46.857 21.328a6.605 6.605 0 0 0-1.049-.485l-.367-.136.13-.242c.897-1.693.107-3.521-2.06-4.774-3.21-1.856-8.424-1.856-11.617 0l-.469.271-.4-.304a3.325 3.325 0 0 0-.4-.277 6.012 6.012 0 0 0-5.446 0c-1.51.897-1.506 2.285 0 3.154l13.277 7.668a9.292 9.292 0 0 0 8.418 0c2.308-1.343 2.296-3.532-.017-4.875",
  fill: "#BEFFFC"
}), React.createElement("path", {
  d: "M46.874 26.203a9.292 9.292 0 0 1-8.418 0L25.18 18.535c-1.506-.869-1.512-2.257 0-3.154a6.012 6.012 0 0 1 5.445 0c.14.082.274.175.401.277l.4.304.47-.271c3.192-1.856 8.406-1.856 11.616 0 2.167 1.253 2.957 3.081 2.06 4.774l-.13.242.367.136c.363.131.714.293 1.05.485 2.312 1.343 2.324 3.532.016 4.875",
  fill: "#BEFFFC"
}), React.createElement("path", {
  d: "M28.305 39.083s5.094 2.721 5.932 9.84c.754 6.412-2.47 6.68-3.909 6.35-1.292-.297-24.049-13.404-24.702-13.817C3.363 40.023.183 37.062.183 31.058c0-6.908 5.094-5.233 6.211-4.466 1.116.768 21.911 12.491 21.911 12.491zm20.111-12.88a9.292 9.292 0 0 1-8.418 0L26.72 18.535c-1.506-.869-1.512-2.257 0-3.154a6.012 6.012 0 0 1 5.445 0c.14.082.274.175.4.277l.4.304.47-.271c3.193-1.856 8.407-1.856 11.617 0 2.167 1.253 2.957 3.081 2.059 4.774l-.13.242.368.136c.363.131.714.293 1.049.485 2.313 1.343 2.325 3.532.017 4.875z",
  stroke: "#28348A",
  strokeWidth: 0.4
}), React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.4,
  mask: "url(#b)",
  d: "M69.641 35.249h7.476v-7.006h-7.476z"
}), React.createElement("path", {
  d: "M76.144 25.445a2.765 2.765 0 0 0-5.531 0v2.856M1.924 26.345L46.252.573s1.836-.986 3.914.18c1.733.973 22.11 12.868 22.11 12.868s4.161 2.327 5.431 7.828M66.282 35.343L33.216 54.507",
  stroke: "#28348A",
  strokeWidth: 0.4,
  mask: "url(#b)"
}), React.createElement("path", {
  d: "M82.656 29.483a9.104 9.104 0 1 1-18.208 0 9.104 9.104 0 0 1 18.208 0zM5.63 30.806c1.117.768 21.911 12.491 21.911 12.491M5.63 34.086c1.117.768 21.911 12.491 21.911 12.491M5.63 37.366c1.117.768 21.911 12.491 21.911 12.491",
  stroke: "#28348A",
  strokeWidth: 0.4,
  mask: "url(#b)"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 83 56",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/aboutUs/ecoSystem/external_data.svg